import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';
import style from './style.module.less';

/**
 * PickupInstructions component for entering pickup instructions
 * @param {object} props
 * @param {string} [props.value] - The current instructions value
 * @param {(instructions: string) => void} [props.onChange] - Callback when instructions change
 * @returns {React.ReactElement} The PickupInstructions component
 */
export const PickupInstructions = ({ value, onChange }) => {
  const onInstructionChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div>
      <Text textType={TextType.Label} value={<FormattedMessage {...messages.pickupInstructionsLabel} />} />
      <textarea className={style['instructions-textarea']} maxLength={200} onChange={onInstructionChange} rows={2} value={value} />
    </div>
  );
};
